import React from "react";
import "./ContactUs.css";
import contus from "../../assets/imgs/contus.png";
import email from "../../assets/imgs/icons/email.png";
import phone from "../../assets/imgs/icons/phone.svg";
import loc from "../../assets/imgs/icons/loc.png";
import ContactForm from "../ContactForm/ContactForm";

import { Helmet } from "@dr.pogodin/react-helmet";

function ContactUs() {

  return (
    <div className="cntsMN">
      <Helmet>
              <title>Contact Us | PAYTECH ADVISOR</title>
            </Helmet>
      <div className="maxW">
        <div className="cntsWRp">
          <div className="cntsLft">
            <div className="clftWrp">
              <img src={contus} alt="contus" />
            </div>
            <div className="addwrap">

              <div className="addCon">
                <div className="cndiWrp">
                  <img src={phone} alt="phone" />
                </div>
                <div className="conDtls">
                  <h6>Phone</h6>
                  <a href="tel:+919811137560">+91-9811137560</a>
                </div>
              </div>

              <div className="addCon">
                <div className="cndiWrp">
                  <img src={email} alt="email" />
                </div>
                <div className="conDtls">
                  <h6>Email</h6>
                  <a href="mailto:kamal@paytechadvisors.com">Kamal@paytechadvisors.com</a>
                </div>
              </div>

              <div className="addCon">
                <div className="cndiWrp">
                  <img src={loc} alt="address" />
                </div>
                <div className="conDtls">
                  <h6>Address</h6>
                  <a
                    href="https://www.google.com/maps?q=Assotech+Business+Cresterra,+Sector-135,+Noida,+Gautam+Buddha+Nagar,+Uttar+Pradesh-201305"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Assotech Business Cresterra, Sector 135 Noida
                  </a>
                </div>
              </div>

            </div>
          </div>

          <div className="cntsRyt">
            <div className="cfrmWrp">
              <h2>Contact Us</h2>
              <p>Submit the form, and our team will reach out to you.</p>
              <ContactForm />
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

export default ContactUs;
